import LinkPreview from './extenders/LinkPreview';
import commentBodies from './utils/commentBodies';
export default [new LinkPreview().content('flarum/forum/components/Comment', commentBodies)];